import React from "react";
import { ConversationMeta } from "@/utils/axios/claudeUtils.ts";
import { Trash } from "lucide-react";

interface ConversationItemProps {
  conversation: ConversationMeta;
  isActive: boolean;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

const ConversationItem: React.FC<ConversationItemProps> = ({
  conversation,
  isActive,
  onSelect,
  onDelete,
}) => {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete(conversation.id);
  };

  const handleSelect = (e: React.MouseEvent) => {
    e.preventDefault();
    onSelect(conversation.id);
  };

  return (
    <div
      className={`w-full flex justify-between items-center rounded-md p-2 ${
        isActive ? "bg-purple-100 text-purple-900" : "hover:bg-gray-100"
      } transition-colors duration-150 ease-in-out cursor-pointer text-sm`}
      onClick={handleSelect}
      role="button"
      tabIndex={0}
      aria-pressed={isActive}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleSelect(e as unknown as React.MouseEvent);
        }
      }}
    >
      <div className="flex-1 truncate mr-2 max-w-[calc(100%-36px)]">
        {conversation.title || "Sans titre"}
      </div>
      <button
        onClick={handleDelete}
        className={`btn btn-xs btn-ghost btn-circle flex-shrink-0 ${
          isActive
            ? "text-purple-700 hover:bg-purple-200"
            : "text-gray-500 hover:bg-gray-200"
        }`}
        aria-label="Supprimer la conversation"
      >
        <Trash className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default ConversationItem;
